import React, { PropTypes } from 'react';
import PersonEntry from '../Entry'
import Alphabet from '../Alphabet'
import ContentHeader from '../../shared/ContentHeader';
import DetailHeader from '../../shared/DetailHeader';
import localize from '../../../localize'
import { getCurrentLanguage } from '../../../localData';
import NoRecordsFound from '../../shared/NoRecordsFound';

const Persons = ({ persons, type, relay }) => {
    const people = persons.map(edge => <PersonEntry key={ edge.node.id } person={ edge.node } />);

    const l = (key) => {
        const str = `${getCurrentLanguage()}.components.${type}.${key}`;
        return localize(str);
    };

    return (
        <div className="container">
            <DetailHeader
                relay={ relay }
                detail={{
                    title: l('title'),
                }}
                simple
            />
            <div id="detailHeader">
                <ContentHeader title={ l('title') } />
            </div>
            <Alphabet personType={ type.toLowerCase() } />
            <div className="page-content">
                <ul className="object-list person-list">
                    { people.length ? people : <NoRecordsFound lang={ getCurrentLanguage() } /> }
                </ul>
            </div>
        </div>
    )
};

Persons.propTypes = {
    persons: PropTypes.array.isRequired,
    type: PropTypes.oneOf([
        'Designers',
        'Producers',
    ]).isRequired,
};

Persons.defaultProps = {
    persons: [],
    relay: PropTypes.object.isRequired,
};

export default Persons;


// WEBPACK FOOTER //
// ./app/components/Person/Persons/index.jsx